export default "__VITE_PUBLIC_ASSET__5f8e727a__"